module.exports = __webpack_public_path__ + "img/bus.49bb5dd6.svg";